import { CourseStats } from '@yandex-int/k-common/typings';

import * as constants from './constants';

export const getCourseStatsRequest = (courseId: number) =>
    <const>{
        type: constants.GET_COURSE_STATS_REQUEST,
        courseId,
    };

export const getCourseStatsSuccess = (courseId: number, stats: CourseStats) =>
    <const>{
        type: constants.GET_COURSE_STATS_SUCCESS,
        courseId,
        stats,
    };

export const getCourseStatsError = (courseId: number) =>
    <const>{
        type: constants.GET_COURSE_STATS_ERROR,
        courseId,
    };

export const clearCourseStats = (courseId: number) =>
    <const>{
        type: constants.CLEAR_COURSE_STATS,
        courseId,
    };
